module.exports = __webpack_public_path__ + "media/images/brand/line-d2d7ba05d50208eb5eb5bdc00bd4db3c.svg";